import { render } from "./Add_Template_Modal.vue?vue&type=template&id=54e800d6&scoped=true"
import script from "./Add_Template_Modal.vue?vue&type=script&lang=js"
export * from "./Add_Template_Modal.vue?vue&type=script&lang=js"

import "./Add_Template_Modal.vue?vue&type=style&index=0&id=54e800d6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54e800d6"]])

export default __exports__